import { Flex, Skeleton, Space } from '@mantine/core';

export const TableSkeleton = () => {
  return (
    <Flex gap={5} direction="column">
      <Skeleton height={40} radius="sm" />
      <Space h={10} />
      <Skeleton height={40} radius="sm" />
      <Skeleton height={40} radius="sm" />
      <Skeleton height={40} radius="sm" />
      <Skeleton height={40} radius="sm" />
      <Skeleton height={40} radius="sm" />
    </Flex>
  );
};
